import React, { useState } from "react";
import { Input } from "../../components/ui/Input/Input";
import { InputPassword } from "../../components/ui/InputPassword/InputPassword";
import Checkbox from "../../components/ui/Checkbox/Checkbox";
import { Button } from "../../components";
import { AuthContainer } from "../../components/AuthContainer/AuthContainer";
import { ROUTES } from "../../helpers/routes";
import { login } from "../../services/slices/user";
import styles from "./Login.module.scss";
import { useAppDispatch, useAppSelector } from "../../services/hooks";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";

export const Login = () => {
  const [email, setEmail] = useState("");
  const { user } = useAppSelector((state) => state.user);
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.user);
  const [errorFetch, setErrorFetch] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (loading) return;
    setErrorFetch(false);
    const loginData = { username: email, password };
    const resultAction = await dispatch(login(loginData));

    if (login.fulfilled.match(resultAction)) {
      // Дополнительные действия после успешного логина, например, перенаправление
      setErrorFetch(false);
      navigate("/");
    } else {
      setErrorFetch(true);
      resetForm();
    }
  };

  const resetForm = () => {
    setEmail("");
    setPassword("");
  };

  if (user) <Navigate to={ROUTES.home} state={{ from: location }} replace />;

  return (
    <AuthContainer
      title="Login"
      subtitle="Enter your credentials to access your account"
    >
      {errorFetch && <ErrorMessage message={"Invalid email or password"} />}
      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          value={email}
          setValue={setEmail}
          id="email"
          type="email"
          required
          label="Email"
          placeholder="example@mail.com"
        />

        <InputPassword
          value={password}
          setValue={setPassword}
          id="password"
          label="Password"
          required
          placeholder="Enter the password"
        />

        <div className={styles.loginOptions}>
          <Checkbox checked={rememberMe} onChange={setRememberMe} name={1}>
            Remember me
          </Checkbox>
          <a
            type="button"
            href={ROUTES.forgotPassword}
            className={styles.forgotPasswordBtn}
          >
            Forgot password
          </a>
        </div>

        <Button type="submit" disabled={loading}>
          {loading ? (
            <>
              <Loader />
              Logging in...
            </>
          ) : (
            "Login"
          )}
        </Button>
        <p className={styles.signupText}>
          Don’t have an account?{" "}
          <a href={ROUTES.register} className={styles.link}>
            Sign up
          </a>
        </p>
      </form>
    </AuthContainer>
  );
};

export default Login;
